import { SpinnerLoader } from '@kula-ai/components';

/**
 * Stands in for a menu item's icon while that item's action is running.
 *
 * Shaped as an icon component (`{ size }`) so it drops straight into
 * `ActivityMenuItem.icon`, where `ActivityMenuItemIcon` renders it like any other —
 * the spinner then sits exactly where the action's own icon was, rather than the
 * item shifting as it swaps.
 *
 * Its own file because a module exporting a component must export ONLY components,
 * or Fast Refresh silently stops working for it.
 */
export const ActivityBusyIcon = ({ size = 18 }: { size?: number }) => (
  <SpinnerLoader size="sm" style={{ width: size, height: size }} />
);
